<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'systemMemberUpload',
})
</script>
<template>
  <div>
    <a-card>
      <div class="system-member-upload-search mb20">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
              <a-form-item label="上传日期">
                <a-range-picker v-model:value="dateTime" format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="上传日期" @change="changeDateList" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
              <a-form-item label="文件名称">
                <a-input v-model:value="state.tableData.param.fileName" placeholder="请输入文件名称" :maxlength="20" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
              <div class="card-col-action btn-group">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary"><SearchOutlined />查询</ant-button>
                <ant-button class="resetFun" @click="resetFun" type="primary"><RedoOutlined />重置</ant-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading" :pagination="false" row-key="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'status'">
            {{ `成功：${record.successCount}条 / 失败：${record.failCount}条` }}
          </template>
          <template v-else-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small" @click="onDownload(record)">下载文件</a-button>
              <a-button v-if="record.failCount > 0" type="link" size="small" danger @click="onDownloadFail(record)">下载失败记录</a-button>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination
        v-model:current="state.tableData.param.pageNum"
        v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total"
        :page-size-options="['10', '20']"
        show-size-changer
        :show-total="(total) => `共 ${total} 条`"
        :showQuickJumper="true"
        @change="onPageChange"
        @show-size-change="onShowSizeChange"
      />
    </a-card>
  </div>
</template>

<script setup lang="ts" name="systemMemberUpload">
import { reactive, ref, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons-vue'
import { useMember } from '@/store/system/member'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'

const memberStore = useMember()

const columns = [
  { title: '序号', key: 'index', width: 60, customRender: ({ index }: { index: number }) => index + 1 },
  { title: '文件名称', dataIndex: 'fileName', key: 'fileName', ellipsis: true },
  { title: '操作人员', dataIndex: 'opUser', key: 'opUser', ellipsis: true },
  { title: '人员ID', dataIndex: 'opNumber', key: 'opNumber', ellipsis: true },
  { title: '上传时间', dataIndex: 'modifyTime', key: 'modifyTime', ellipsis: true },
  { title: '导入结果', key: 'status', ellipsis: true },
  { title: '操作', key: 'action', width: 200 }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      start: '',
      end: '',
      fileName: ''
    }
  }
})

const dateTime = ref<string[]>([])

const resetFun = () => {
  state.tableData.param.start = ''
  state.tableData.param.end = ''
  state.tableData.param.fileName = ''
  state.tableData.param.pageNum = 1
  dateTime.value = []
}

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const data: any = await fetchWithPaginationFallback(
      (param) => memberStore.staffImportPageData(param),
      state.tableData.param
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const changeDateList = () => {
  state.tableData.param.start = dateTime.value?.[0] || ''
  state.tableData.param.end = dateTime.value?.[1] || ''
}

const onDownload = (row: any) => {
  const downloadUrl = row.srcFile
  if (!downloadUrl) {
    message.warning('文件不存在')
    return
  }
  const fileName = row.fileName || '文件'
  downloadByUrl(downloadUrl, fileName)
}

const onDownloadFail = (row: any) => {
  const downloadUrl = row.resultFile
  if (!downloadUrl) {
    message.warning('失败记录文件不存在')
    return
  }
  const fileName = `失败记录_${row.fileName || ''}`
  downloadByUrl(downloadUrl, fileName)
}

const downloadByUrl = (url: string, fileName: string) => {
  const separator = url.includes('?') ? '&' : '?'
  const disposition = `attachment;filename=${encodeURIComponent(fileName)}`
  const fullUrl = `${url}${separator}response-content-disposition=${encodeURIComponent(disposition)}`
  window.open(fullUrl, '_blank')
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

onMounted(() => {
  getTableData()
})
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt15 {
  margin-top: 15px;
}

.btn-group {
  display: flex;
  white-space: nowrap;
}
</style>
